import { Attribute, Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { NgModel } from '@angular/forms';
import { FinanceGLAccountMask } from '../../../finance/shared/directives/mask/finance-gl-account-mask';
import { getServerDate } from '../../helpers/time-helpers.model';
import { DateMask } from './DateMask';
import { IMaskFormatter } from './IMaskFormatter';
import { PhoneMask } from './PhoneMask';
import { PhoneWithExtensionMask } from './PhoneWithExtensionMask';

@Directive({
    selector: '[mask][ngModel]',
    providers: [NgModel],
    host: {
        '(keyup)': 'onInputChange($event)',
        '(keypress)': 'beforeInputChange($event)',
        '(click)': 'onClick($event)',
        '(ngModelChange)': 'onValueChange(model)',
    }
})

export class MaskDirective {
    private hasValueChangedCalled: boolean;
    formatter: IMaskFormatter;
    maskPattern: string;
    placeHolderCounts: number;
    modelValue: string;
    viewValue: string;
    inputElement: any;
    shortDate: boolean;

    @Input() maskResult: boolean;
    private isShortDate: boolean;

    @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
    copyString: string;
    captureCaret: any;
    count = 0;

    constructor(public model: NgModel, @Attribute('mask') maskPattern: string, @Attribute('isShortDate') shortDate: boolean, public el: ElementRef) {
        this.copyString = maskPattern.slice(0);
        let dividers: string[];
        this.inputElement = el.nativeElement;
        dividers = maskPattern.replace(/\*/g, '').split('');
        dividers.push(' ');
        this.generatePattern(maskPattern);
        this.formatter = this.getFormatter();
        if (this.formatter) {
            this.formatter.dividers = dividers;
            this.formatter.inputElement = this.inputElement;
        }
        this.isShortDate = shortDate;
        this.hasValueChangedCalled = false;
    }

    getFormatter(): IMaskFormatter {
        if (this.copyString === DateMask.shortDateMask) {
            return new DateMask();
        } else if (this.copyString === PhoneMask.phoneMask) {
            return new PhoneMask();
        } else if (this.copyString === PhoneWithExtensionMask.phoneMask) {
            return new PhoneWithExtensionMask();
        } else if (this.copyString == FinanceGLAccountMask.glAccountMask) {
            return new FinanceGLAccountMask();
        }
    }

    // Since placeholder has syling issues in IE in regards to our styling, handling it through TS
    onClick(event) {
        if (this.formatter) {
            if (this.modelValue) {
                this.formatter.setCaretOnClick(this.modelValue);
            }

            this.inputElement.placeholder = this.formatter.placeholder;
            this.formatter.captureCaret = this.inputElement.selectionStart;
            this.captureCaret = this.inputElement.selectionStart;
        }
    }

    // stops the user from entering extra characters/input-values
    beforeInputChange(event: any) {
        if (this.formatter) {
            const model = this.formatter.getModelValue(event, event.target.value);
            // keycode 8 (backspace) does not raise the keypress event in IE or Chrome, but it does in Firefox
            // excluding keycode 8 from consideration for restricting input for consistency across browsers
            if (model && event.keyCode && event.keyCode === 8) {
                return true;
            } else {
                return this.formatter.restrictInput(model);
            }
        }
    }

    /**
     * converts a Date object to a short date so that it looks nice in the input box. The attribute isShortDate needs to be set on the <input>
     * @param model
     */
    onValueChange(model: any) {

        if (this.hasValueChangedCalled || !this.isShortDate) {
            return;
        }
        this.hasValueChangedCalled = true; // use it to initialize the data and don't call it again. ever.

        if (!model) {
            return;
        }

        if (model.constructor.name === 'NgModel') {

            var v = this.inputElement;
            // if (model.valueAccessor && model.valueAccessor._elementRef && model.valueAccessor._elementRef.nativeElement) {
            // let val = <string>model.valueAccessor._elementRef.nativeElement.value;
            if (this.inputElement) {
                const val = <string> this.inputElement.value;
                if (val) {
                    const date = new Date(val); // just make sure that date is valid
                    if (date) {
                        model.valueAccessor._elementRef.nativeElement.value = getServerDate(date);
                        // this.inputElement.value = getServerDate(date);

                    }
                }
            }

            return;
        }
        var l = <NgModel> model;

        // below code should never be called

        if (typeof (model) === 'string') {
            const date = new Date(<string> model);
            if (date) {
                model = getServerDate(date);
            }
        }
    }

    // Events bound to ngModelChange
    onInputChange(event: any) {
        if (this.formatter) {
            this.inputElement.placeholder = this.formatter.placeholder;
            event.preventDefault();
            this.modelValue = this.formatter.getModelValue(event, event.target.value);
            let stringToFormat = this.modelValue;
            stringToFormat = this.formatter.padString(stringToFormat);
            this.viewValue = this.format(stringToFormat);
            event.target.value = this.viewValue; // since event is always bound to the model (Without this you will notice extra space)
            if (this.modelValue.length === 0) {  // Displays placeholder back when entire input is deleted
                this.viewValue = null;
                this.ngModelChange.emit(null);
                this.model.valueAccessor.writeValue(null);
            } else {
                this.model.valueAccessor.writeValue(this.viewValue);      // 'viewValue' is tied to the view
            }
            this.formatter.setCaret(this.modelValue, event);
        }
    }

    // Transforms **/**/**** to {1}{2}/{3}{4}/{5}{6}{7}{8}
    generatePattern(patternString) {
        this.placeHolderCounts = (patternString.match(/\*/g) || []).length;
        for (var i = 0; i < this.placeHolderCounts; i++) {
            patternString = patternString.replace('*', '{' + i + '}');
        }
        this.maskPattern = patternString;
    }

    // Replaces {i} with the input, ex: 08/29/1980
    format(s) {
        let formattedString = this.maskPattern;
        for (var i = 0; i < this.placeHolderCounts; i++) {
            formattedString = formattedString.replace('{' + i + '}', s.charAt(i));
        }
        return formattedString;
    }
}
